import { decodeHTMLEntities } from 'js/app/utils/common.util';
import { getCookie, setCookie } from 'js/utils/cookie.util';

const cookieNameDefault = 'btag';
const documentRefSiteCookieName = 'ctag';
const customFieldsMapping = {
    btag: 'custom19',
    ctag: 'custom20',
    referrerId: 'referrer'
};
const cookieNameMapping = {
    referrer: 'referrerId'
};

const knownRefSites = [
    {
        searcher: new RegExp(/^\s*$/),
        refVal: '000000'
    },
    {
        searcher: new RegExp(/^http(?:s)?:\/\/(?:www\.)?google\.[a-z.]+(?:\/.*)?$/gi),
        refVal: '000001'
    },
    {
        searcher: new RegExp(/^http(?:s)?:\/\/(?:www\.)?bing\.com(?:\/.*)?$/gi),
        refVal: '000002'
    },
    {
        searcher: new RegExp(/^http(?:s)?:\/\/(?:www\.)?yahoo\.com(?:\/.*)?$/gi),
        refVal: '000003'
    },
    {
        searcher: new RegExp(/^http(?:s)?:\/\/(?:www\.)?facebook\.com(?:\/.*)?$/gi),
        refVal: '100000'
    }
];

export const getRefereeCookie = (cookieName = cookieNameDefault) => {
    const cookie = getCookie(cookieNameMapping[cookieName] || cookieName);
    const cookieObj = {};

    if (cookie) {
        const propName = customFieldsMapping[cookieName] || cookieName;

        cookieObj[propName] = cookie;
    }

    return cookieObj;
};

export const setRefereeCookie = (urlParams = {}, cookieName = cookieNameDefault, successCallback) => {
    const param = {}.toString.call(urlParams?.get) === '[object Function]' ? urlParams?.get(cookieName) : null;

    if (param) {
        setCookie(cookieNameMapping[cookieName] || cookieName, decodeHTMLEntities(param), { expires: 1, path: '/' });

        if (successCallback) {
            successCallback();
        }
    }

    setSiteRefCookie();
};

export const setSiteRefCookie = () => {
    if (getCookie(cookieNameDefault)) {
        return;
    }

    const referredFrom = knownRefSites.find(({ searcher }) => window.document.referrer.match(searcher));

    if (referredFrom) {
        setCookie(documentRefSiteCookieName, referredFrom.refVal, { expires: 1, path: '/' });
    }
};

export const unsetRefereeCookie = () => {
    setCookie(cookieNameDefault, '', { expires: -1, path: '/' });
    setCookie(documentRefSiteCookieName, '', { expires: -1, path: '/' });
};
